import React from "react";
import { defaultFont } from "../../../assets/fonts/defaultFont";
import LiroyText from "./LiroyText";

export function Text16({ children, containerStyle, ...props }) {
    return (
        <LiroyText {...props} size={16} fontWeight={defaultFont.regular}>
            {children}
        </LiroyText>
    );
}
